import { createContext, useContext, useState } from "react";
import { useAuth } from "../Authentication/AuthenticationProvider";
import { axios_helper_async } from "helpers/Axios";
import { useNotifications } from "../Notifications/NotificationProvider";
import { useMessages } from "../Messages/MessageProvider";
import { NotificationType } from "../Notifications/notificationTypes";

const CartContext = createContext<{
    cart: {
        items: number;
        updateCart: () => void;
    };
}>({
    cart: {
        items: 0,
        updateCart: () => {}
    }
});

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const { id } = useAuth();
    const { setMessages } = useMessages();
    const { setNotifications, showNotification } = useNotifications();
    const [items, setItems] = useState<number>(0);

    const update = async () => {
        try {
            const body = {
                customerId: id
            }
            const response = await axios_helper_async<number>("/Cart/Get-Cart-Count", 'GET', body);

            setMessages(response.messages);
            setNotifications(response.notifications);

            if(response.isSuccess && response.data !== null){
                setItems(response.data);
            }
        }
        catch(ex: any){
            showNotification(`${ex}`, NotificationType.Error);
        }
    }

    const cart = {
        items: items,
        updateCart: update
    }

    return(
        <CartContext.Provider value={{ cart }}>
            {children}
        </CartContext.Provider>
    )
};

export const useCart = () => useContext(CartContext);